import { useQuery } from "@tanstack/react-query";

import { SATOSPortal } from "@/DataAdapter/SATOSPortal";

export class NodeQueryKeys {
	static readonly nodes = "nodes";
	static readonly checklists = "checklists";
	static readonly importPlan = "importPlan";
}

export const useFetchImportPlan = (
	active: boolean,
	nodeId: number | undefined,
	checklistId: number | undefined,
) => {
	return useQuery({
		queryKey: [
			NodeQueryKeys.nodes,
			nodeId,
			NodeQueryKeys.checklists,
			checklistId,
			NodeQueryKeys.importPlan,
		],
		queryFn: () => SATOSPortal.GetImportPlan(nodeId!, checklistId!),
		enabled: active && (!!checklistId || !!nodeId),
	});
};

export const useFetchNewImportPlan = (nodeId: number | undefined) => {
	return useQuery({
		queryKey: [NodeQueryKeys.nodes, nodeId, NodeQueryKeys.importPlan],
		queryFn: () => SATOSPortal.GetNewImportPlan(nodeId!),
		enabled: !!nodeId,
	});
};
